import { render, staticRenderFns } from "./AuthorImage.vue?vue&type=template&id=07e1a6aa"
import script from "./AuthorImage.vue?vue&type=script&lang=ts"
export * from "./AuthorImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports